import React from "react"

import Lottie from "v2/Lib/lottie"
import * as Loader from "v2/Assets/lottie-cloud-animation.json"
import { LOCAL_STORAGE_THEME_MODE_KEY } from "v2/Components/ThemeMode"
import { getPreThemePalette } from "v2/Services/preThemePalette"
import constants from "Services/constants"
import { getCurrentProduct } from "v2/Services/product"

const LOCAL_STORAGE_REFRESH_KEY = "page_load_refresh_key"
const refreshKeySet = window.localStorage.getItem(LOCAL_STORAGE_REFRESH_KEY)

function ProfitDrivePageLoader () {
  return (
    <>
      <style>
        {`
          .pd-loader-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 24px;
          }

          .pd-icon-container {
            position: relative;
            width: 120px;
            height: 120px;
          }

          .pd-icon-square {
            width: 120px;
            height: 120px;
            border-radius: 28px;
            background: linear-gradient(135deg, #16A34A, #22C55E);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            animation: pd-square-pulse 2s ease-in-out infinite;
          }

          .pd-ring {
            position: absolute;
            border-radius: 50%;
            border: none;
            background: rgba(255, 255, 255, 0.08);
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.6);
            opacity: 0;
            animation: pd-ring-pulse 2s ease-out infinite;
          }

          .pd-ring:nth-child(1) {
            width: 110px;
            height: 110px;
            animation-delay: 0s;
          }

          .pd-ring:nth-child(2) {
            width: 85px;
            height: 85px;
            animation-delay: 0.2s;
          }

          .pd-ring:nth-child(3) {
            width: 60px;
            height: 60px;
            animation-delay: 0.4s;
          }

          .pd-icon-p {
            position: relative;
            z-index: 2;
            font-size: 90px;
            font-weight: 900;
            color: #fff;
            line-height: 1;
            animation: pd-p-pulse 2s ease-in-out infinite;
            font-family: "Helvetica Neue", Arial, sans-serif;
          }

          .pd-pulse-ring {
            position: absolute;
            top: 0;
            left: 0;
            width: 120px;
            height: 120px;
            border-radius: 28px;
            border: 3px solid #22C55E;
            animation: pd-outer-pulse 2s ease-out infinite;
          }

          .pd-pulse-ring:nth-child(2) {
            animation-delay: 0.6s;
          }

          @keyframes pd-square-pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }

          @keyframes pd-ring-pulse {
            0% {
              transform: translate(-50%, -50%) scale(0.6);
              opacity: 0;
            }
            30% { opacity: 1; }
            70% { opacity: 1; }
            100% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 0;
            }
          }

          @keyframes pd-p-pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.85; transform: scale(1.04); }
          }

          @keyframes pd-outer-pulse {
            0% {
              transform: scale(1);
              opacity: 0.6;
            }
            100% {
              transform: scale(1.45);
              opacity: 0;
            }
          }
        `}
      </style>
      <div className="pd-loader-wrap">
        <div className="pd-icon-container">
          <div className="pd-pulse-ring" />
          <div className="pd-pulse-ring" />
          <div className="pd-icon-square">
            <div className="pd-ring" />
            <div className="pd-ring" />
            <div className="pd-ring" />
            <span className="pd-icon-p">p</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default function PageLoad () {
  /* NOTE not using any theme or mui stuff, because it is used in index.js before anything is initialized */
  const darkMode = window.localStorage.getItem(LOCAL_STORAGE_THEME_MODE_KEY) === "dark"
  const [showButton, setShowButton] = React.useState(false)
  const product = getCurrentProduct()
  const palette = getPreThemePalette(darkMode, product)

  const hardReloadCache = React.useCallback(() => {
    window.localStorage.removeItem("pointOfSaleState")
    window.localStorage.removeItem("pointOfSaleTransactions")
    window.localStorage.removeItem("clouderp-api-cache")
    window.location.reload(true)
  }, [])

  React.useEffect(() => {
    if (refreshKeySet) {
      window.localStorage.removeItem(LOCAL_STORAGE_REFRESH_KEY)
    }
    const timer = setTimeout(() => {
      if (!refreshKeySet) {
        window.localStorage.setItem(LOCAL_STORAGE_REFRESH_KEY, "true")
        window.location.reload()
      } else {
        setShowButton(true)
      }
    }, 20000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <div style={{
      left: 0,
      top: 0,
      width: "100vw",
      height: "100vh",
      background: palette.background,
    }}
    >
      <div style={{
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        height: "10%",
        flexDirection: "column",
      }}
      >
        {product === constants.ORGANIZATION_PRODUCT_PROFITDRIVE ? (
          <ProfitDrivePageLoader />
        ) : (
          <Lottie animationData={Loader} />
        )}
        <div style={{
          textAlign: "center",
          fontWeight: 500,
          fontSize: "1rem",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          lineHeight: 1.5,
          letterSpacing: "0.00938em",
          color: palette.text,
        }}
        >
          {product === constants.ORGANIZATION_PRODUCT_PROFITDRIVE ? (
            <div style={{ marginTop: "16px" }}>
              <span style={{ fontSize: "2rem", fontWeight: 700, lineHeight: 1 }}>profit</span>
              <span style={{ fontSize: "calc(2rem + 1px)", fontWeight: 700, lineHeight: 1, color: "#16a34a" }}>drive</span>
            </div>
          ) : (
            <>
              Cloud
              <strong>ERP</strong>
            </>
          )}
        </div>
      </div>
      {showButton && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            padding: "20px",
            color: palette.text,
          }}
        >
          <h2>Túl sokáig látod ezt a képernyőt?</h2>
          <h4>
            Lehet a böngésződ nem a legfrissebb verziót próbálja betölteni.
          </h4>
          <span
            style={{
              cursor: "pointer",
              backgroundColor: palette.primary,
              borderColor: palette.primary,
              color: palette.primaryContrast,
              padding: "6px 16px",
              marginBottom: "16px",
              borderRadius: "4px",
            }}
            onClick={hardReloadCache}
          >
            Kattints ide az újratöltéshez
          </span>
          <h5>
            Ha a hiba továbbra is fenn marad, az <a style={{ color: palette.text }} target="_blank" href="https://help.clouderp.hu/hc/hu-hu/articles/12764197489053-Mi-az-a-gyors%C3%ADt%C3%B3t%C3%A1r-a-b%C3%B6ng%C3%A9sz%C5%91ben-%C3%A9s-hogyan-lehet-t%C3%B6r%C3%B6lni-" rel="noreferrer">alábbi linken</a> találsz segítséget a böngésző adatok törléséhez
          </h5>
        </div>
      )}
    </div>
  )
}
